export default {
  main: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}
